import { DefaultError, useMutation } from "@tanstack/react-query";
import { bulkUpdateFaqsList } from "../api/bulkUpdateFaqsList";
import { changeFaqGroup } from "../api/changeFaqGroup";
import { getFaqsListByFaqGroup } from "../api/getFaqsListByFaqGroup";
import { invalidateFaqsListByFaqGroupQuery } from "../queries/useFaqsListByFaqGroupQuery";
import { FaqDataToCreate } from "../types";

type Params = {
  targetFaqGroupId: string;
  faqId: string;
  data: FaqDataToCreate;
};

export const useChangeGroupFaqMutation = () => {
  return useMutation<void, DefaultError, Params>({
    mutationFn: async ({ data, targetFaqGroupId }) => {
      const targetFaqList = await getFaqsListByFaqGroup(targetFaqGroupId);

      const dataToUpdate =
        targetFaqList.reduce((acc, faqData) => {
          if (faqData.order < data.order) {
            return acc;
          }

          return {
            ...acc,
            [faqData.id]: {
              order: faqData.order + 1,
            },
          };
        }, {}) ?? {};

      await Promise.all([
        changeFaqGroup(targetFaqGroupId, data),
        bulkUpdateFaqsList(targetFaqGroupId, dataToUpdate),
      ]);
    },
    onSuccess: (_, { targetFaqGroupId }) => {
      invalidateFaqsListByFaqGroupQuery(targetFaqGroupId);
    },
    onError: (e) => {
      console.error("Error occurred when changing faq group", e);
    },
  });
};
